var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "confirm-dialog" }, [_c('div', { staticClass: "confirm-title" }, [_c('i', { staticClass: "el-icon-question" }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.confirmTitle))])]), _vm._v(" "), _c('div', { staticClass: "confirm-content" }, [_vm._v(_vm._s(_vm.confirmContent))])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };